import { EditProfile } from "../components/EditProfile/EditProfile"
export const ProfileEdit=()=>{

    return <>
        <EditProfile/>
    </>
}